import { NAME } from './constants';
import type { ConfirmSlice } from './reducer';

export const getDomainState = (state: ConfirmSlice) => state[NAME];
